module.exports = __webpack_public_path__ + "img/u8acc-00044.2d1e13e0.png";